export const supportedFileExtensions = ['doc', 'docx', 'odt', 'rtf', 'txt', 'html'] as const
export const MAX_FILE_SIZE = 1048576 * 2

export const isFileNotBig = (file: File) => {
  if (file.size > MAX_FILE_SIZE) {
    return false
  }

  return true
}

export const isFileSupportedExtensions = (file: File) => {
  const supportedExtensions = supportedFileExtensions.join('|')

  const regExp = new RegExp(`\\.(${supportedExtensions})$`, 'i')

  if (!regExp.test(file.name)) {
    return false
  }

  return true
}

export const getListOfFileTypesCopy = (conjunction: 'and' | 'or') =>
  supportedFileExtensions
    .map((ext: string) => `.${ext}`)
    .reduce((acc, curr, idx, arr) => {
      if (idx === 0) {
        acc += curr
      } else if (idx === arr.length - 1) {
        acc += `, ${conjunction} ${curr}`
      } else {
        acc += ', ' + curr
      }
      return acc
    }, '')
